import React from 'react';
import HeaderTwo from "./header/HeaderTwo";
import FooterThree from "./footer/FooterThree";

const Layout = ({children}) => {
    return (
        <>
            <main className="page-wrapper">
                <HeaderTwo btnStyle="btn-small round btn-icon" HeaderSTyle="header-non-transparent" />
                {children}
                <FooterThree />
            </main>
        </>
    )
}
export default Layout;
